export const PG_SSL_WARNING_START =
  "Warning: SECURITY WARNING: The SSL modes 'prefer', 'require', and 'verify-ca' are treated as aliases for 'verify-full'."
export const PG_SSL_WARNING_END =
  'See https://www.postgresql.org/docs/current/libpq-ssl.html for libpq SSL mode definitions.'
export const NODE_TRACE_WARNING_HINT = '(Use `node --trace-warnings'
export const DRIZZLE_NOISE_PATTERNS = [
  /^No config path provided, using default 'drizzle\.config\.ts'$/,
  /^Reading config file '.+drizzle\.config\.ts'$/,
  /^Using 'pg' driver for database querying$/,
  /^\[.\] Pulling schema from database\.\.\.$/u,
  /^\[.\] Changes applied$/u
]
// A buffered partial line is held back only while it could still become one of the
// suppressed lines above; anything else (e.g. an interactive prompt, which has no
// trailing newline) is flushed immediately so it stays visible.
export const SUPPRESSIBLE_LINE_STARTS = [
  'No config path provided',
  "Reading config file '",
  "Using 'pg' driver",
  '(node:',
  '['
]
/**
 * drizzle-kit refuses to render its conflict-resolver prompts when the child's
 * stdout is a pipe (it requires both stdin and stdout to be TTYs). When this
 * error appears during an interactive push, the run is re-executed fully
 * terminal-attached so the prompts can render.
 */
export const DRIZZLE_TTY_PROMPT_ERROR = 'Interactive prompts require a TTY terminal'
export const LOGIN_NOISE_PATTERNS = [
  /^vercel cli \d/i,
  /^>?$/,
  /^npm (warn|notice)/i,
  /congratulations! you are now signed in/i,
  /^to deploy something/i,
  /to deploy every commit automatically/i,
  /connect a git repository/i,
  /vercel\.link\/git/i
]
export const DETAIL_MAX_LINES = 15
